import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// import crossModalImg from '../../../assets/images/crossModal.png';
import { addSheetSettings } from '../../../redux/actions/sheetSettings';
import { verifySheet } from '../../../services/extraServices';
import Loader from '../../Loader';

const AddSheetFormModal = ({ setOpenSheetModal, openSheetModal, type }) => {
	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	const [sheetUrl, setSheetUrl] = useState('');

	const dispatch = useDispatch();

	const sheetSettings = useSelector((state) => state.sheetSettings);
	const { loading, success } = sheetSettings;

	useEffect(() => {
		if (success) {
			setOpenSheetModal(false);
			setSheetUrl('');
		}
	}, [success, setOpenSheetModal]);

	const submitSheetFrom = async () => {
		try {
			const sheetDetails = await verifySheet(
				sheetUrl,
				userInfo?.gmBackendToken
			);
			if (!sheetDetails) {
				toast.error(
					`We couldn't verify your spreadsheet. Please check the spreadsheet permission'`
				);
				return false;
			}

			dispatch(
				addSheetSettings({
					spreadsheetId: sheetDetails?.spreadsheetId,
					spreadsheetTitle: sheetDetails?.spreadsheetTitle,
					type: type === 'data' ? 'export' : 'preApprove',
				})
			);
		} catch (error) {
			toast.error('Something went wrong, Please try again');
		}
	};

	return (
		<div className={`modalDivWraper customizedModal ${openSheetModal ? 'activated' : ''}`}>
			{loading && <Loader />}
      <div className="modalHeaderWraper">
      {/* <img
					src={crossModalImg}
					className='modalCloseBtn'
					alt=''
					onClick={() => setOpenSheetModal(false)}
				/> */}
				<h4 className='modalHeading'>Add Sheet</h4>
      </div>
			<div className='innerModalWraper'>
				
				<div className='fieldWrapers modalFields'>
          <div className="indformField">
            <span className="labelFields">Enter Google Sheet URL</span>
					<input
						type='text'
						className='inputBox'
						placeholder='Google Sheet URL'
						onChange={(e) => setSheetUrl(e.target.value)}
					/>
          </div>
					<div className='buttonWraper customizeWraper'>
						<button className='confirmBtn' onClick={submitSheetFrom}>
							Submit
						</button>
						<button
							className='cancelBtn'
							onClick={() => setOpenSheetModal(false)}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddSheetFormModal;
